// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectPrintLayoutItem_wrapper__2tX6s","wrapperActive":"SelectPrintLayoutItem_wrapperActive__ibSmf","text":"SelectPrintLayoutItem_text__x5DYf"};